import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ActiveSessionApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.routes = ENV.API_ROUTES;
  }

  async initSession(token, { therapyId, patients }) {
    const url = `${this.baseApi}/revi/session/init`;
    const params = {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify({ therapyId, patients }),
    };
    return this._fetch(url, params);
  }

  async listMySessions(
    token,
    { page = 1, limit = 10, status, from, to, search = "" } = {},
  ) {
    const q = new URLSearchParams({ page, limit });
    if (status) q.append("status", status);
    if (from) q.append("from", from);
    if (to) q.append("to", to);
    if (search) q.append("search", search);

    const url = `${this.baseApi}/revi/session/my?${q.toString()}`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  async getDetail(token, sessionId) {
    const url = `${this.baseApi}/revi/session/${sessionId}`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  async getPatientActiveSession(token) {
    const url = `${this.baseApi}/revi/session/patient/active`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  // ✅ options opcional: { roomMode: "shared" | "individual" }
  async launchScene(token, sessionId, options) {
    const url = `${this.baseApi}/revi/session/${sessionId}/launch`;

    const hasBody = options && typeof options === "object";

    return this._fetch(url, {
      method: "POST",
      headers: {
        ...cabecerasApi(token),
        ...(hasBody ? { "Content-Type": "application/json" } : {}),
      },
      ...(hasBody ? { body: JSON.stringify(options) } : {}),
    });
  }

  async nextScene(token, sessionId) {
    const url = `${this.baseApi}/revi/session/${sessionId}/next`;
    return this._fetch(url, {
      method: "PATCH",
      headers: cabecerasApi(token),
    });
  }

  async close(token, sessionId) {
    const url = `${this.baseApi}/revi/session/${sessionId}/close`;
    return this._fetch(url, {
      method: "PATCH",
      headers: cabecerasApi(token),
    });
  }

  async submitEvaluation(
    token,
    { sessionId, patientId, evaluationId, answers, comments },
  ) {
    const url = `${this.baseApi}/revi/session/submit-evaluation`;
    return this._fetch(url, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        patientId,
        evaluationId,
        answers,
        comments,
      }),
    });
  }

  async deleteSession(token, sessionId) {
    const url = `${this.baseApi}/revi/session/${sessionId}`;
    return this._fetch(url, {
      method: "DELETE",
      headers: cabecerasApi(token),
    });
  }

  async _fetch(url, params) {
    const response = await fetch(url, params);
    const json = await response.json().catch(() => ({}));

    if (response.status >= 200 && response.status < 300) return json;
    throw json;
  }
}
